module.exports = __webpack_public_path__ + "img/失败报错-@3x.2ece6af3.png";